<template>
  <div class="page">
    <div class="header">
      <img
        class="logo"
        src="../assets/images/logo.png"
        alt=""
        @click="goBack()"
      />
    </div>
    <div class="container">
      <div class="section-search">
        <input
          type="text"
          class="search-input"
          placeholder="請輸入關鍵字搜索"
          v-model="keyword"
        />
        <div class="search">
          <div class="search-btn" @click="search()">搜索</div>
        </div>

        <div class="search-list" v-if="isShow">
          <ul v-if="searchTitle.length">
            <li v-for="(subItem, subIndex) in searchTitle" :key="subIndex">
              <div class="sub-item-li item" @click="goArticle(subItem)">
                <div>
                  {{ subItem.title }}
                </div>
                <div>
                  {{ formatDate(subItem.created_ts) }}
                </div>
              </div>
            </li>
          </ul>
          <div v-else class="no-data">暫無數據</div>
        </div>
      </div>
      <div class="section-list">
        <img
          v-if="!isShow"
          style="
            width: 0.54rem;
            height: 0.54rem;
            position: absolute;
            right: 0;
            top: -0.15rem;
            z-index: 3;
          "
          src="../assets/images/homePc/men.png"
          alt=""
        />
        <!-- <div class="scroll-container">
          <div class="scroll-content">
            <div
              class="item"
              v-for="item in searchList"
              :key="item.id"
              :class="{ 'active-li': item.id == moduleId }"
              @click="goModule(item)"
            >
              {{ item.name }}
            </div>
          </div>
        </div> -->
        <div class="scroll-container">
          <div class="com-tab">
            <i class="arrow icon-arrow-left" @click="scrollTab('left')"></i>
            <ul id="tab-menu">
              <li
                :id="'li' + index"
                v-for="(item, index) in searchList"
                :key="item.id"
                :class="{
                  active: item.id === moduleId
                }"
                @click="goModule(item)"
              >
                {{ item.name }}
              </li>
            </ul>
            <i class="arrow icon-arrow-right" @click="scrollTab('right')"></i>
          </div>
        </div>
        <div class="module_list">
          <ul>
            <li
              v-for="(subItem, subIndex) in showSubList"
              :key="subIndex"
              class="sub-item-li"
            >
              <div class="sub-item" @click="goArticle(subItem)">
                <div>
                  {{ subItem.title }}
                </div>
                <div>
                  {{ formatDate(subItem.created_ts) }}
                </div>
              </div>
            </li>
          </ul>
        </div>
        <div v-if="showSubList.length">
          <ul class="page-ul">
            <li v-for="i in count" :key="i" @click="changePage(i)">
              <div
                class="page-li"
                :class="{ 'page-active-li': i == current }"
              ></div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getArticles, getModules } from '../global/api/api'
import { formatTime } from '../global/js/utils'

export default {
  data() {
    return {
      searchList: [],
      showSubList: [],
      moduleId: 0,
      formatDate: formatTime,
      current: 1,
      page_size: 5,
      total: 0,
      count: 0,
      offsetCount: 0,
      keyword: '',
      isShow: false,
      searchTitle: []
    }
  },
  async mounted() {
    await this.getModuleList()
  },
  methods: {
    search() {
      this.getArticleList(1)
    },

    // 滑动tab页签
    scrollTab(direction) {
      if (this.searchList.length === 0) return
      let menu = document.querySelector('#tab-menu')
      // 计算ul宽度和当前
      let ulWidth = menu.clientWidth
      const getWidth = (idName) => {
        let li = document.querySelector(idName)
        return li.clientWidth
      }
      let liWidth = 0
      this.searchList.forEach((ele, index) => {
        liWidth = liWidth + getWidth(`#li${index}`)
      })
      // 根据方向和宽度计算偏移量
      if (liWidth < ulWidth) return
      let distance = this.offsetCount * 100

      if (direction === 'left') {
        if (this.offsetCount > 0) {
          this.offsetCount = this.offsetCount - 1
        }
      } else if (direction === 'right') {
        if (ulWidth + distance < liWidth) {
          this.offsetCount = this.offsetCount + 1
        }
      }
      distance = this.offsetCount * 100
      menu.scrollTo({
        left: distance,
        behavior: 'smooth'
      })
      console.log(distance)
    },
    getModuleList() {
      getModules({ game_id: 2 }).then((res) => {
        if (res.code == 0 && res.data && res.data.length > 0) {
          this.searchList = [...res.data]
          this.moduleId = res.data[0].id
          this.getArticleList()

          console.log('this.searchList', this.searchList)
        }
      })
    },
    getArticleList(type) {
      let params = {
        game_id: 2
      }
      if (!type) {
        params.current = this.current
        params.page_size = this.page_size
      }
      if (this.moduleId > 0) {
        params.module_id = this.moduleId
      }
      if (this.keyword) {
        params.title = this.keyword
      }
      getArticles(params).then((res) => {
        if (res.code === 0) {
          if (type == 1 && this.keyword) {
            this.searchTitle = res.data.list
            this.isShow = true
          } else {
            this.total = res.data.total
            this.count = Math.ceil(this.total / this.page_size)
            this.showSubList = res.data.list
          }
        }
      })
    },
    goModule(item) {
      this.moduleId = item.id
      this.current = 1
      this.showSubList = []
      this.getArticleList()
    },
    changePage(i) {
      this.current = i
      this.getArticleList()
    },
    goArticle(item) {
      this.$router.push({
        path: '/article',
        query: {
          id: item.id
        }
      })
    },
    goBack() {
      this.$router.push({
        path: '/home'
      })
    }
  },
  watch: {
    keyword: function (val) {
      if (!val) {
        this.isShow = false
      }
    }
  }
}
</script>

<style lang="less" scoped>
.page {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100vw;
  height: 100vh;
  background: #000;
  overflow: hidden;
}

/* PC端 */
@media screen and (min-width: 769px) {
  @import '../assets/css/gonglue_pc.less';
}

/* 移动端  */
@media screen and (max-width: 769px) {
  @import '../assets/css/article_m.less';
}
</style>
